import React, { useEffect, useState } from 'react'
import { get } from '../api/fetch'

import { useParkingContext } from '../context/ParkingContext'
import Loader from './Loader/Loader'
import Toast from './Toast/Toast'
import ManageBooking from './Popup/Parking/ManageBooking/ManageBooking'
import ParkingForm from './Forms/Parking/ParkingForm'

/** Render parking multi step form
 * @param {string} langauge app language {en | de | it}
 */
export default function ParkingPage({ language }) {
  const { pageData, error, setError, successInfo, setSuccessInfo, loader, setLoader } = useParkingContext()
  const [vehicleTypeOptions, setVehicleTypeOptions] = useState([])

  // * All Translations
  const {
    title,
    notes,
    buttons,
    errors,
    ticketsInformation,
    buyerInformation,
    paymentInformation,
    manageBooking,
    feedback,
    pdfTemplate,
  } = pageData

  // * allowed language for calendar locale prop
  const calenderLocale = {
    en: 'en-US',
    de: 'de-DE',
    it: 'it-IT',
  }

  // * Ticket Types
  const TICKET_TYPE = [
    {
      vehicleType:'CAR',
      value: 'daily',
      label: {
        de: 'LAKE PARK',
        it: 'LAKE PARK',
        en: 'LAKE PARK',
      },
    },
    {
      vehicleType:'CAR',
      value: 'special',
      label: {
        de: 'LAKE PARK AND EAT PASS',
        it: 'LAKE PARK AND EAT PASS',
        en: 'LAKE PARK AND EAT PASS',
      },
    },
    {
      vehicleType:'TABLE',
      value: 'daily',
      label: {
        de: 'EAT PASS',
        it: 'EAT PASS',
        en: 'EAT PASS',
      },
    },

  ]

  // * Parking Template
  const PARKING_TEMPLATE = `<!DOCTYPE html><html><head><title>Title</title><meta http-equiv="X-UA-Compatible" content="IE=edge"><!-- [endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">a{font-weight:700;color:#331b0c;text-decoration:none!important}body{margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;font-family:Tahoma,Geneva,sans-serif}table,td{border-collapse:collapse;mso-table-lspace:0;mso-table-rspace:0}img{border:0;height:auto;line-height:100%;outline:0;text-decoration:none;-ms-interpolation-mode:bicubic;display:block}p{display:block;margin:0}</style></head><body style="background:#fff;text-align:center"><div style="background:#fff;width:794px;height:1122px;text-align:center;vertical-align:top;margin:0 auto"><table width="100%" border="0" cellspacing="0" cellpadding="0" align="center" style="margin:0 auto;background-color:#fff"><tbody><tr><td><table width="100%" cellspacing="0" align="center"><tbody><tr align="center"><td><table><tbody><tr><td height="16"></td></tr><tr><td><img alt="Hotel Lago Di Braies" src="https://cdn.mts-online.com/parkingimages/eggerhof-logo.png" style="width:100%;height:110px" tabindex="0"></td></tr></tbody></table></td></tr><tr align="center"><td><table><tbody><tr><td height="8"></td></tr><tr><td><h2>{{lblBookingConfirmation}}</h2></td></tr><tr><td height="8"></td></tr></tbody></table></td></tr><tr><td style="height:1px;background-color:#331b0c"></td></tr></tbody></table></td></tr><tr><td><table width="85%" cellspacing="0" align="center"><tbody><tr><td height="8"></td></tr><tr><td height="8"></td></tr><tr align="center"><td><h4 style="text-transform:uppercase;text-decoration:underline">{{lblTicketDetails}}</h4></td></tr><tr><td height="8"></td></tr><tr align="center"><td><table width="100%" cellspacing="0" align="center"><tbody><tr><td height="4"></td><td height="4"></td></tr><tr><td align="left">{{lblReservationId}}</td><td align="right">{{reservationId}}</td></tr><tr><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td></tr><tr><td height="4"></td><td height="4"></td></tr><tr><td align="left">{{lblArrival}}</td><td align="right">{{arrival}}</td></tr><tr><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td></tr><tr><td height="4"></td><td height="4"></td></tr><tr><td align="left">{{lblDeparture}}</td><td align="right">{{departure}}</td></tr><tr><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td></tr><tr><td height="4"></td><td height="4"></td></tr><tr><td align="left">{{lblVehiclePlate}}</td><td align="right">{{plate}}</td></tr><tr><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td></tr><tr><td height="4"></td><td height="4"></td></tr><tr><td align="left">{{lblParkingPrice}}</td><td align="right">{{price}}</td></tr><tr><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td><td style="height:1px;width:50%;border-bottom:1px solid #ddd"></td></tr><tr><td height="4"></td><td height="4"></td></tr><tr><td align="left">{{lblServicePrice}}</td><td align="right">{{servicePrice}}</td></tr></tbody></table></td></tr><tr><td height="20"></td></tr><tr><td align="left">{{lblRefundNote}}</td></tr><tr><td height="20"></td></tr></tbody></table></td></tr><tr><td><table width="100%" cellspacing="0" align="center"><tbody><tr align="center"><td style="height:1px;background-color:#331b0c"></td></tr><tr align="center"><td><table cellspacing="0" align="center"><tbody><tr><td height="12"></td></tr><tr><td></td></tr><tr><td height="8"></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr style="text-align:left">{{lblParkingRule}}</tr></tbody></table></div></body></html>`
  const PARKING_TEMPLATE_withQR = `<!DOCTYPE html> <html> <head> <title>Title</title> <meta http-equiv="X-UA-Compatible" content="IE=edge"><!-- [endif]--> <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"> <meta name="viewport" content="width=device-width,initial-scale=1"> <style type="text/css"> a { font-weight: 700; color: #331b0c; text-decoration: none !important } body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Tahoma, Geneva, sans-serif } table, td { border-collapse: collapse; mso-table-lspace: 0; mso-table-rspace: 0 } img { border: 0; height: auto; line-height: 100%; outline: 0; text-decoration: none; -ms-interpolation-mode: bicubic; display: block } p { display: block; margin: 0 } </style> </head> <body style="background:#fff;text-align:center"> <div style="background:#fff;width:794px;height:1122px;text-align:center;vertical-align:top;margin:0 auto"> <table width="100%" border="0" cellspacing="0" cellpadding="0" align="center" style="margin:0 auto;background-color:#fff"> <tbody> <tr> <td> <table width="100%" cellspacing="0" align="center"> <tbody> <tr align="center"> <td> <table> <tbody> <tr> <td height="16"></td> </tr> <tr> <td><img alt="Hotel Lago Di Braies" src="https://cdn.mts-online.com/parkingimages/eggerhof-logo.png" style="width:100%;height:110px" tabindex="0"> </td> </tr> </tbody> </table> </td> </tr> <tr align="center"> <td> <table> <tbody> <tr> <td height="8"></td> </tr> <tr> <td> <h2>{{lblBookingConfirmation}}</h2> </td> </tr> <tr> <td height="8"></td> </tr> </tbody> </table> </td> </tr> <tr> <td style="height:1px;background-color:#331b0c"></td> </tr> </tbody> </table> </td> </tr> <tr align="center"> <td> <table width="85%"> <tr> <td style="width:50%"><img alt="QR Code" src="{{qrCodeImage}}" style="width:200px;height:200px;justify-items:center;" tabindex="0"> </td> <td style="width:50%"> <table width="100%" cellspacing="0" align="center"> <tbody> <tr> <td height="6"></td> </tr> <tr align="center"> <td> <h4 style="text-transform:uppercase;text-decoration:underline"> {{lblTicketDetails}}</h4> </td> </tr> <tr> <td height="4"></td> </tr> <tr align="center"> <td> <table width="100%" cellspacing="0" align="center"> <tbody> <tr> <td height="4"></td> <td height="4"></td> </tr> <tr> <td align="left">{{lblReservationId}}</td> <td align="right">{{reservationId}}</td> </tr> <tr> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> </tr> <tr> <td height="4"></td> <td height="4"></td> </tr> <tr> <td align="left">{{lblArrival}}</td> <td align="right">{{arrival}}</td> </tr> <tr> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> </tr> <tr> <td height="4"></td> <td height="4"></td> </tr> <tr> <td align="left">{{lblDeparture}}</td> <td align="right">{{departure}}</td> </tr> <tr> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> </tr> <tr> <td height="4"></td> <td height="4"></td> </tr> <tr> <td align="left">{{lblVehiclePlate}}</td> <td align="right">{{plate}}</td> </tr> <tr> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> </tr> <tr> <td height="4"></td> <td height="4"></td> </tr> <tr> <td align="left">{{lblParkingPrice}}</td> <td align="right">{{price}}</td> </tr> <tr> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> <td style="height:1px;width:50%;border-bottom:1px solid #ddd"> </td> </tr> <tr> <td height="4"></td> <td height="4"></td> </tr> <tr> <td align="left">{{lblServicePrice}}</td> <td align="right">{{servicePrice}}</td> </tr> </tbody> </table> </td> </tr> <tr> <td height="20"></td> </tr> </tbody> </table> </td> </tr> <tr> <td colspan="2" align="left" style="width:100%; padding:10px;">{{lblRefundNote}}</td> </tr> </table> </td> </tr> <tr> <td> <table width="100%" cellspacing="0" align="center"> <tbody> <tr align="center"> <td style="height:1px;background-color:#331b0c"></td> </tr> <tr align="center"> <td> <table cellspacing="0" align="center"> <tbody> <tr> <td height="12"></td> </tr> <tr> <td></td> </tr> <tr> <td height="8"></td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </td> </tr> <tr style="text-align:left">{{lblParkingRule}}</tr> </tbody> </table> </div> </body> </html>`

  const fetchVehicleCategories = async () => {
    try {
      const res = await get(
        `vehicleCategory/get`,
        null,
        {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      )
      const data = await res.json();
      if (data.data) {
        let options = [];
        data.data.forEach((i) => {
          if (i.isActive === true || i.isActive === undefined)
            options.push({ value: i.vehicleTypeName, label: { en: i.en, de: i.de, it: i.it } })
        })
        setVehicleTypeOptions([...options])
      }
      else {
        console.log({ err: data })
      }
    }
    catch (err) {
      console.log({ err })
    }
  }

  useEffect(() => {
    fetchVehicleCategories()
  }, [])

  /**
   * @description Update template with specified values
   * @param {string} template template string
   * @param {Object} valuesToReplace template data which is replaced from the  given template
   * @returns Updated template
   */
  const updateTemplateString = (template, valuesToReplace) => {
    for (let data in valuesToReplace) {
      if (data && valuesToReplace[data]) {
        template = template.replace(`{{${data}}}`, valuesToReplace[data])
      }
    }
    return template
  }

  return (
    <>
      {/* * LOADER */}
      {loader && <Loader></Loader>}

      {/* * TOAST ERRORS */}
      {error && (
        <Toast
          varient="danger"
          handleClick={() => setError('')}
          message={
            error[language] ||
            error ||
            errors?.errWentWrong[language] ||
            `Something went wrong. Please try again later.`
          }
          autoDelete={true}
          autoDeleteTime={5000}
        ></Toast>
      )}

      {/* * TOAST INFO */}
      {successInfo && (
        <Toast
          varient="success"
          handleClick={() => setSuccessInfo('')}
          message={successInfo[language] || successInfo}
          autoDelete={true}
          autoDeleteTime={5000}
        ></Toast>
      )}

      <section className="MTS__px-2 sm:MTS__px-0 sm:MTS__container MTS__flex MTS__flex-col MTS__gap-8">
        {/* * Manage Parking Popups */}
        <section>
          <ManageBooking
            pageData={{ title, notes, buttons, manageBooking, errors, feedback, ticketsInformation, pdfTemplate }}
            language={language}
            error={error}
            setError={setError}
            successInfo={successInfo}
            setSuccessInfo={setSuccessInfo}
            loader={loader}
            setLoader={setLoader}
            calenderLocale={calenderLocale}
            VEHICLE_TYPE={vehicleTypeOptions}
            TICKET_TYPE={TICKET_TYPE}
            PARKING_TEMPLATE={PARKING_TEMPLATE}
            updateTemplateString={updateTemplateString}
          ></ManageBooking>
        </section>

        {/* * PARKING FORM */}
        <section className="lg:MTS__w-11/12">
          <ParkingForm
            pageData={{
              errors,
              notes,
              buttons,
              ticketsInformation,
              buyerInformation,
              paymentInformation,
              pdfTemplate,
            }}
            language={language}
            setError={setError}
            setLoader={setLoader}
            calenderLocale={calenderLocale}
            VEHICLE_TYPE={vehicleTypeOptions}
            TICKET_TYPE={TICKET_TYPE}
            PARKING_TEMPLATE={PARKING_TEMPLATE}
            updateTemplateString={updateTemplateString}
          ></ParkingForm>
        </section>
      </section>
    </>
  )
}
